import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';

import { companiesQueryKeys } from './queryKeys';

/** Coresignal's industry names, the only values a company's industry can take. They don't change while the app runs. */
export const useIndustriesQuery = () =>
  useQuery({
    queryKey: companiesQueryKeys.industries(),
    queryFn: async () => {
      const { data } = await fetchClient.GET(endpoints.industries);
      return data ?? [];
    },
    staleTime: Infinity,
  });
